import { render, staticRenderFns } from "./PrimaryContactCell.vue?vue&type=template&id=2ef90040"
import script from "./PrimaryContactCell.vue?vue&type=script&lang=js"
export * from "./PrimaryContactCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports